import { useEffect } from "react";

const GTM_ID = "GTM-5T5TGHD9";

export const GoogleTagManager = () => {
  useEffect(() => {
    // if (process.env.NODE_ENV !== "production") return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(script);
  }, []);

  return null;
};

export default GoogleTagManager;
